export default __webpack_public_path__ + "static/media/logo-footer-001-300x123.62327346.png";